export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
